import { FormGroup } from "../../../components/form";
import * as yup from "yup";

export const appealRequestForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "sectionHeader",
      },
      label: "Appeal Request Details",
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "appealReason",
      label: "Reason for Appeal",
      validation: yup.string().trim().required("A response is required").max(500, "No more than 500 characters may be entered in this field"),
      warn: "Outline the reason/s for the appeal",
      extendedlabel: (
        <p>
          Briefly note the reason an appeal is requested (for example; 'Requesting an increase to AA hours' or 'Appealing ineligible outcome').
          Further information on how to submit an appeal is available within the{" "}
          <a
            target="_blank"
            href="https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/Kindergarten-KIS-portal-user-guide.pdf"
            rel="noreferrer">
            KIS portal User Guide
          </a>
          <i className="pi pi-external-link"></i>
          (section 7). Please ensure any detailed information you wish to be considered in the appeal is included within the appeal application
          created after this step.
        </p>
      ),
    },
    {
      type: "field",
      key: "appealApplicationId",
      fieldType: "button",
      label: "Open Appeal Application",
      props: {
        className: "form-button",
        disabled: false,
      },
      expressionProps: {
        onClick: (context) => () => {
          window.open(context.redirectUrl, "_blank");
        },
      },
      hideExpression: (context) => !context.hasAppeal,
    },
  ],
};
